import BaseButton from '@/components/BaseButton'
import SuccessDialog from '@/components/SuccessDialog'
import ErrorDialog from '@/components/ErrorDialog'
import goTopButton from '@/components/GoTopButton'
import goBottomButton from '@/components/GoBottomButton'
import Pager from '@/components/PagerComponent'
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

export default {

  components: {
    Pager,
    BaseButton,
    SuccessDialog,
    ErrorDialog,
    goTopButton,
    goBottomButton
  },

  data () {
    return {
      responseErr: '',
      error: false,
      isProcessing: false
    }
  },

  methods: {
    downloadExcelParam () {
      this.exportProducts()
    },

    async exportProducts () {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('products/export').then(
        response => {
          const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
          var hiddenElement = document.createElement('a')
          hiddenElement.href = URL.createObjectURL(blob)
          hiddenElement.target = '_blank'
          hiddenElement.download = dayjs().format('YYYYMMDD-HHmmss') + ' - MoveUP-PAR-01-Dossier de Paramétrage.xlsx'
          document.body.appendChild(hiddenElement)
          hiddenElement.click()
          document.body.removeChild(hiddenElement)

          this.isProcessing = false
          this.showSuccess('Produits exportés avec succès')
          this.reset()
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = (error.response.data || 'BAD_REQUEST')
          this.showError(this.responseErr)
        }
      )
    },

    showError (msg) {
      this.$refs.errorDialogRef.showError(msg)
    },

    showSuccess (msg) {
      this.$refs.successDialogRef.showSuccess(msg)
    },

    reset () {
      this.error = false
    }
  }
}
